import React from 'react';
import SitesList from 'components/Sites';

const ProjectSites = ({ projectID }: any) => <SitesList dataId={projectID} valueKey={'projectId'} />;

export default ProjectSites;
